import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, TextInput, Text } from '@mantine/core';

import { useSignUpManager } from '../../api/signUpManager';
import { useManagerForm } from '../../hooks/useManagerForm';
import { Platform } from '../../types';

import { Departments } from '@/types';

type Props = {
  platform: Platform;
  pageId: string;
  department: Departments;
};

export const AddModal = NiceModal.create(({ pageId, platform, department }: Props) => {
  const modal = useModal();
  const form = useManagerForm();

  const { mutate, isLoading } = useSignUpManager({ onSuccess: modal.remove });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      title={`New manager (${department.toUpperCase()})`}
    >
      <form
        onSubmit={form.onSubmit(({ username, password }) =>
          mutate({ pageId, platform, username, password, department })
        )}
      >
        <Text mt="sm" mb="xs" size="sm">
          Username
        </Text>
        <TextInput
          required
          placeholder="Username"
          value={form.values.username}
          onChange={(event) => form.setFieldValue('username', event.currentTarget.value)}
          mb="xl"
          error={form.errors.username}
        />
        <Text mb="xs" size="sm">
          Password
        </Text>
        <TextInput
          required
          placeholder="Password"
          value={form.values.password}
          onChange={(event) => form.setFieldValue('password', event.currentTarget.value)}
          mb="xl"
          error={form.errors.password}
        />
        <Group justify="right">
          <Button loading={isLoading} type="submit">
            Add
          </Button>
        </Group>
      </form>
    </Modal>
  );
});
